/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getTrainee = /* GraphQL */ `query GetTrainee($id: ID!) {
  getTrainee(id: $id) {
    id
    first_name
    last_name
    display_name
    display_company
    visitor_type
    phone
    location_id
    company_id
    region_id
    checked_in
    checkin_id
    timestamp
    onsite_pk
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetTraineeQueryVariables,
  APITypes.GetTraineeQuery
>;
export const listTrainees = /* GraphQL */ `query ListTrainees(
  $filter: ModelTraineeFilterInput
  $limit: Int
  $nextToken: String
) {
  listTrainees(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      first_name
      last_name
      display_name
      display_company
      visitor_type
      phone
      location_id
      company_id
      region_id
      checked_in
      checkin_id
      timestamp
      onsite_pk
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTraineesQueryVariables,
  APITypes.ListTraineesQuery
>;
export const syncTrainees = /* GraphQL */ `query SyncTrainees(
  $filter: ModelTraineeFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncTrainees(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      first_name
      last_name
      display_name
      display_company
      visitor_type
      phone
      location_id
      company_id
      region_id
      checked_in
      checkin_id
      timestamp
      onsite_pk
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncTraineesQueryVariables,
  APITypes.SyncTraineesQuery
>;
export const getCheckIn = /* GraphQL */ `query GetCheckIn($id: ID!) {
  getCheckIn(id: $id) {
    id
    trainee_id
    location_id
    timestamp
    type
    trainee_name
    trainee_phone
    trainee_company
    display_company
    visitor_type
    onsite_pk
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCheckInQueryVariables,
  APITypes.GetCheckInQuery
>;
export const listCheckIns = /* GraphQL */ `query ListCheckIns(
  $filter: ModelCheckInFilterInput
  $limit: Int
  $nextToken: String
) {
  listCheckIns(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      trainee_id
      location_id
      timestamp
      type
      trainee_name
      trainee_phone
      trainee_company
      display_company
      visitor_type
      onsite_pk
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCheckInsQueryVariables,
  APITypes.ListCheckInsQuery
>;
export const syncCheckIns = /* GraphQL */ `query SyncCheckIns(
  $filter: ModelCheckInFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncCheckIns(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      trainee_id
      location_id
      timestamp
      type
      trainee_name
      trainee_phone
      trainee_company
      display_company
      visitor_type
      onsite_pk
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncCheckInsQueryVariables,
  APITypes.SyncCheckInsQuery
>;
